import { render, staticRenderFns } from "./accessRecordDialog.vue?vue&type=template&id=72ff1ea4&scoped=true"
import script from "./accessRecordDialog.vue?vue&type=script&lang=js"
export * from "./accessRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./accessRecordDialog.vue?vue&type=style&index=0&id=72ff1ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff1ea4",
  null
  
)

export default component.exports